import React from 'react';
import RelatedContentItem from './RelatedContentItem.jsx';

class RelatedContent extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'RelatedContent';
  }


  /**
   * Renders component
   * @returns {Array<ReactElement>} An array of React elements
   */
  renderItems() {
    const items = [];
    const relatedStoryData = this.props.data.content.stories;

    for (let i = 0; i < relatedStoryData.length; i++) {
      const key = 'related-content-item-' + i;

      items.push(
        <RelatedContentItem
          data={relatedStoryData[i]}
          key={key}
        />
      );
    }

    return items;
  }


  /**
   * Renders component
   * @returns {ReactElement} React element
   */
  render() {
    const items = this.renderItems();
    const data = this.props.data;
    const className = 'component-related-content section-' +
      this.props.iteration + '-' + data.id + ' prev-section-type-' + this.props.prevSectionType;

    return (
      <div className={className}>
        <header className='header'>
          <h1 className='headline'>{data.header}</h1>
        </header>
        <div className='items'>
          {items}
        </div>
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - The related content data
 * @prop {Number} iteration - The iteration of the element
 * @prop {String} prevSectionType - The type of the previous section
 */
RelatedContent.propTypes = {
  data: React.PropTypes.object,
  iteration: React.PropTypes.number,
  prevSectionType: React.PropTypes.string,
};


export default RelatedContent;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/RelatedContent.jsx
 **/